export default {
  blockManager: {
    appendTo: '.block-container',
  },
}
